export default __webpack_public_path__ + "static/media/rain-3-night.87a095ae.svg";